import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Ordine} from '../../_models/Ordine';
import {AuthenticationService} from '../../_services/authentication.service';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {ModalController} from '@ionic/angular';
import {constants} from '../../_helpers/constants';
import {MovimentoTrasferimentoComponent} from '../movimenti/movimento-trasferimento/movimento-trasferimento.component';
import {OrdineAllegatiComponent} from '../ordine-allegati/ordine-allegati.component';
import {OrdineGroup} from '../../_models/OrdineGroup';
import {LocalService} from '../../_services/local.service';
import {Subscription} from 'rxjs';
import {StatoEnum} from '../../_models/generated/stato-enum';
import {LicenzeService} from '../../_services/licenze.service';

@Component({
  selector: 'app-ordine-info',
  templateUrl: './ordine-info.component.html',
  styleUrls: ['./ordine-info.component.scss'],
  standalone: false
})
export class OrdineInfoComponent implements OnInit {
  @Input() ordine: OrdineGroup;
  @Input() lavorata: number;
  @Input() scartata: number;
  @Input() nonConforme: number;
  @Input() qtaRimanente: number;
  @Input() isSendToEsolver: boolean;
  @Input() lastStatoRisorsa: StatoEnum = StatoEnum.SEND_ESOLVER;
  subscriptions: Subscription;
  isStandalone = false;
  loading = false;
  protected readonly constants = constants;
  protected readonly statoRisorsa = StatoEnum;

  constructor(
    public authService: AuthenticationService,
    public licenseService: LicenzeService,
    public organizzazioniService: OrganizzazioniService,
    private ordiniService: LocalService,
    private router: Router,
    private modalCtrl: ModalController) {}

  get canViewStoria(): boolean {
    return this.licenseService.checkPermesso(constants.MOD_PRO_BASE_STORIA);
  }

  get hasMismatch(): boolean {
    return !this.isStandalone &&
      this.round(this.lavorata + this.nonConforme, 6) !== this.round(this.ordine.quantita - this.qtaRimanente, 6);
  }

  // Timeline Storia dell'INTERO ordine (ambito documento, senza idRiga) — entry point: card "N. Reg.".
  openStoria() {
    void this.router.navigate(['/ordini/storia', this.ordine.idDocumento]);
  }

  ngOnInit() {
    this.isStandalone = this.organizzazioniService.isStandalone();
  }

  async launchTrasferimento() {
    const modal = await this.modalCtrl.create({
      component: MovimentoTrasferimentoComponent,
      backdropDismiss: false,
      componentProps: {ordine: this.ordine, fromAvanzamento: true},
      cssClass: 'custom-modal'
    });
    await modal.present();
    await modal.onWillDismiss();
    this.loading = false;
  };

  async openAllegati() {
    const modal = await this.modalCtrl.create({
      component: OrdineAllegatiComponent,
      backdropDismiss: false,
      componentProps: {rifOdP: this.ordine.rifOdP},
      cssClass: 'custom-modal'
    });
    await modal.present();
    await modal.onWillDismiss();
  }

  fixQtaOrdineLocal() {
    this.loading = true;
    const deltaTot = (this.ordine.quantita - this.qtaRimanente);
    this.ordine.ordini.forEach((_ordine: Ordine) => {
      const deltaQta = (deltaTot / this.ordine.ordini.length) - (_ordine.quantitaLavorata + _ordine.quantitaNonConforme);
      _ordine.quantitaLavorata += deltaQta / this.ordine.ordini.length;
      void this.ordiniService.updateOrdine(_ordine);
    });
    this.loading = false;
  }

  round(num: number, decimals: number): number {
    const factor = 10 ** decimals;
    return Math.round(num * factor) / factor;
  }
}
